import { InitialTableState } from '@tanstack/react-table';
import { DataTableTypes } from '../../DataTableTypes';
import { internalColumnType } from '../const/internalColumnType';

export const toInitialColumnConfigurationState = (
  initialState: DataTableTypes.ColumnConfiguration<any> | undefined,
  resizeTableColumns: boolean
): InitialTableState | undefined => {
  if (!initialState) {
    return undefined;
  }
  const { columnOrder, hiddenColumns, columnSizing } = initialState;

  return {
    columnSizing: resizeTableColumns ? (columnSizing ?? {}) : {},
    columnOrder: moveUtilityColumnsToBeginning(columnOrder),
    columnVisibility: hiddenColumns?.reduce((acc, column) => ({ ...acc, [column]: false }), {})
  };
};

const moveUtilityColumnsToBeginning = (columnOrder: DataTableTypes.ColumnConfiguration<any>['columnOrder']) => {
  const filteredArrayOfColumns =
    columnOrder?.filter(
      (column) => column !== internalColumnType.selectRow && column !== internalColumnType.expandRow
    ) ?? [];

  return [internalColumnType.selectRow, internalColumnType.expandRow, ...filteredArrayOfColumns];
};
